import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Picture } from 'ctm-components';
import { quoteFormSelector } from 'ctm-selectors';
import { get, getRulesFromState } from 'ctm-util-functions';
import { getRegoLookupLoadingScreenHeroUrl } from 'ctm-selectors/selectors/brand_content';
import styles from './rego_lookup_loading.css';
import { RegistrationNumber } from '../registration_number/registration_number';

const pictureSchema = (src) => {
    return {
        elementProps: {
            source: [{
                srcSet: src
            }],
            image: {
                alt: '',
                src,
                title: ''
            }
        }
    };
};

/**
 * Render the Rego Lookup Loading component
 * @param {Object} props - the incoming set of props
 * @returns {Node} A component
 */
const _RegoLookupLoading = ({ visibility, mvlRego, heroUrl, ...rest }) => {
    if (!visibility) {
        return null;
    }
    return (
        <div className={styles.root}>
            <div className={styles.container}>
                <p className={styles.text}>Tracking down the car details...</p>
                <RegistrationNumber isLoading {...rest} />
            </div>
            {heroUrl && (
                <div className={styles.footer}>
                    <Picture className={styles.image} {...pictureSchema(heroUrl)} />
                </div>
            )}
        </div>
    );
};

/**
 * Map state to local component props
 * @param {Object} state - the application state
 * @param {Object} props - the incoming set of props
 * @returns {Object} - the set of mapped props for the component
 */
const mapStateToProps = (state, props) => {
    const form = quoteFormSelector(state);
    const rules = getRulesFromState(state, props);
    return {
        visibility: get(rules, 'visibility.result', false),
        rego: form.getIn(['helpers', 'regoLabel']) || '',
        state: form.getIn(['coverDetail', 'vehicle', 'state']) || 'none',
        mvlRego: state.getIn(['vertical', 'quote', 'form', 'coverDetail', 'vehicle', 'rego']) || '',
        heroUrl: getRegoLookupLoadingScreenHeroUrl(state) || null
    };
};

const RegoLookupLoading = connect(mapStateToProps)(_RegoLookupLoading);

RegoLookupLoading.propTypes = {
    visibility: PropTypes.bool,
    rego: PropTypes.string,
    state: PropTypes.string,
    mvlRego: PropTypes.string,
    heroUrl: PropTypes.string
};

export { RegoLookupLoading, _RegoLookupLoading };
